import Cookies from "js-cookie";

export function getToken() {
  return Cookies.get("token");
}

export function getUser() {
  return Cookies.get("user");
}
